import { useContext } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { __RouterContext } from 'react-router';

export default () => useContext(__RouterContext);
